import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PortalService } from '@core/home/portal.service';
import { DarkThemeService } from '@core/theme/dark-theme.service';
import { AsideService } from '@services/aside.service';
import { HomeSidebarService } from '@services/home-sidebar.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'sume-home-header',
    templateUrl: './home-header.component.html',
    styleUrls: ['./home-header.component.scss'],
})
export class HomeHeaderComponent implements OnInit, OnDestroy {
    is_public: boolean = true;
    is_dev = !environment.production;

    sidebar_active = false;
    isLoadingResults = true;
    enablePortais = false;

    subscriptions: Subscription[] = [];

    constructor(
        public portalService: PortalService,
        public apiAuth: AuthService,
        private apiSidebar: HomeSidebarService,
        private asideService: AsideService,
        public darkThemeService: DarkThemeService,
        private router: Router,
        private spinner: NgxSpinnerService
    ) {}

    ngOnInit(): void {
        this.subscriptions.push(
            this.apiSidebar
                .getStatus()
                .subscribe(status => (this.sidebar_active = status))
        );
        this.subscriptions.push(
            this.portalService.loading$
                .pipe(filter(() => this.apiAuth.isLogged))
                .subscribe(l => {
                    if (l) this.spinner.show('seletor-portais');
                    else this.spinner.hide('seletor-portais');
                })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    logoutUser() {
        this.apiAuth.logout();
    }

    toggleSidebar() {
        this.apiSidebar.updateStatus(!this.sidebar_active);
    }
    toggleAside() {
        this.asideService.toggle();
    }

    gotoHome() {
        const link_home = this.portalService.getRoleRoute();
        this.router.navigateByUrl(link_home || '/');
    }
}
